import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import Svg from '../Svg/Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Badge({
  variant,
  intent,
  iconBefore,
  iconAfter,
  children,
  className,
  ...extraProps
}) {
  const computedIntent = variant === 'light' && !intent ? 'muted' : intent;
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "span",
    intent: computedIntent,
    className: clsx('Badge', {
      'Badge--muted': computedIntent === 'muted',
      'Badge--informative': computedIntent === 'info',
      'Badge--positive': computedIntent === 'success',
      'Badge--notice': computedIntent === 'warning',
      'Badge--negative': computedIntent === 'danger',
      'Badge--highlight': computedIntent === 'promotional',
      'Badge--primary': computedIntent === 'primary'
    }, className),
    ...extraProps,
    children: [iconBefore ? /*#__PURE__*/_jsx(Svg, {
      name: iconBefore,
      size: "3x"
    }) : null, children, iconAfter ? /*#__PURE__*/_jsx(Svg, {
      name: iconAfter,
      size: "3x"
    }) : null]
  });
}
export { Badge };